<template>
    <v-layout column>
        <v-flex>
            <v-card xs12 lg12>
                <v-card-text>
                    <v-btn
                            v-for="(icon, index) in icons"
                            :key="index"
                            class="mx-3"
                            icon
                            v-bind:href="icon.link"
                    >
                        <v-icon size="24px" v-bind:color="icon.color">{{ icon.name }}</v-icon>
                    </v-btn>
                </v-card-text>
            </v-card>
        </v-flex>
    </v-layout>

</template>

<script>
    export default {
        name: "Social",
        data: () => ({
            showWechatQR: false,
            icons: [{
                name: 'fab fa-facebook',
                color: '#3b5998',
                link: 'https://www.facebook.com/Prudent-Accounting-Services-LLC-2406049316088134/'
            },
                {name: 'fab fa-twitter', color: '#00aced'},
                {name: 'fab fa-google-plus', color: '#dd4b39'},
                {name: 'fab fa-linkedin', color: '#007bb6'},
                {name: 'fab fa-instagram', color: '#517fa4'},
                {name: 'fab fa-weixin', color: '#09b83e'},
                {name: 'fab fa-weibo', color: '#df2029'}
            ]
        })
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/common/Social.vue